/**
 * Created by 枯荣<panjiankang@cai-inc.com> on 2019-08-12 15:49.
 */
const Server = require( 'helper/server' );
const ImgUpload = require( 'helper/img-upload' );
const Regexp = require( 'helper/regexp' );

const membership = Handlebars.templates[ 'purchasing-federation/member-info/templates/membership' ];
const paymentTpl = Handlebars.templates[ 'purchasing-federation/member-info/templates/payment' ];

const memberShipMap = {
  '1': {
    type: 'president',
    name: '会长'
  },
  '2': {
    type: 'vicePresident',
    name: '副会长'
  },
  '3': {
    type: 'standingDirector',
    name: '常务理事'
  },
  '4': {
    type: 'director',
    name: '理事'
  },
  '5': {
    type: 'nonInstitution',
    name: '非事业单位'
  },
  '6': {
    type: 'institution',
    name: '事业单位'
  }
};

const Membership = {
  async init() {
    const spiner = this.$el.find( '.block__content' ).spin();
    const requestQueue = [ Server.getMemberFeeDetail(), Server.getMemberFeeList(), Server.getMemberFeeChargeDetail() ];
    const request = ( params ) => $.when( ...requestQueue ).then( ( d, l, a ) => ( {
      detail: d[ 0 ],
      list: l[ 0 ] || {},
      account: a[ 0 ]
    } ) );
    try {
      const { detail, list, account } = await request();
      const { memberFeeConfigs } = detail || {};
      const DETAIL = {};
      $.map( memberFeeConfigs, item => {
        const { membership, firstYear, fee } = item;
        const key = memberShipMap[ membership ] && memberShipMap[ membership ].type;
        DETAIL[ key ] = {
          firstYear,
          fee,
          membership,
          membershipName: memberShipMap[ membership ] && memberShipMap[ membership ].name
        };
      } );
      const html = membership( {
        LIST: list.data || [],
        DETAIL,
        ACCOUNT: account
      } );
      this.$el.find( '.info-wrap' ).html( html );
    }
    catch ( e ) {
      alert( e.responseText || '未知错误' );
    }
    spiner.stop();
  },
  renderPaymentSnapshot( root, data, type ) {
    const $wrap = root.find( '.upload-certificate' );
    let html = '';
    if (_.isArray( data )) {
      $.map( data, ( item ) => {
        html += ImgUpload.genImg( item );
      } );
    } else {
      html = ImgUpload.genImg( data );
    }
    if (html) {
      if (type === 'upload') {
        $wrap.find( '.upload-certificate-upload  ' ).before( html );
      } else {
        $wrap.prepend( html );
      }
    }
    const $preview = $wrap.find( '.upload-certificate-preview' );
    if ($preview.length >= 5) {
      $wrap.find( '.upload-certificate-upload' ).hide();
    }
  },
  renderPaymentModal( type, data ) {
    const title = type === 'eidt' ? '编辑' : '缴费';
    const html = paymentTpl( {
      _TITLE_: title,
      _DATA_: data || {}
    } );
    this.$el.find( '#payment-operate-modal #modal-wrap' ).html( html );
    const $form = this.$el.find( '#upload-form' );
    const { attachments = [] } = data;
    Membership.renderPaymentSnapshot( $form, attachments, type !== 'eidt' ? 'init' : '' );
    this.$el.find( '#payment-operate-modal' ).modal( 'show' );
  },
  payment( e ) {
    const el = e.target || e.srcElement;
    let data = {};
    try {
      const originData = $( el ).parents( 'td' ).find( 'input.hide-data' ).val();
      const d = JSON.parse( originData );
      data = _.pick( d, [ 'id', 'year', 'payMethod', 'membershipFee', 'attachments' ] );

    }
    catch ( e ) {

    }
    Membership.renderPaymentModal.apply( this, [ 'pay', data ] );
  },
  editPayment( e ) {
    const el = e.target || e.srcElement;
    let data = {};
    try {
      const originData = $( el ).parents( 'td' ).find( 'input.hide-data' ).val();
      data = JSON.parse( originData );
    }
    catch ( e ) {

    }
    Membership.renderPaymentModal.apply( this, [ 'edit', data ] );
  },
  viewPayment( e ) {
    const el = e.target || e.srcElement;
    const { id } = $( el ).data();
    Server.getMemberFeeAttachments( { id } ).then( res => {
      const { attachments = [] } = res;
      let html = '';
      $.map( attachments, attachment => {
        const { url, name } = attachment;
        html += `<img class="cert-preview" src="${ url }" alt="${ name }">`;
      } );
      this.$el.find( '#cert-view-modal .imgwrap' ).html( `<div class="attachment">${ html }</div>` );
      this.$el.find( '#cert-view-modal' ).modal( 'show' );
    } );
  },
  uploadController( e ) {
    const $form = this.$el.find( '#upload-form' );
    const { size, name } = ImgUpload.getFileSize( e );
    if (size > 5) {
      alert( '附件过大，无法上传成功, 请重新上传' );
      $form[ 0 ].reset();
      return false;
    }
    const fileName = name.substr( name.lastIndexOf( '.' ) ).toUpperCase();
    if (fileName !== '.PNG' && fileName != '.JPG' && fileName !== '.JPEG') {
      alert( '图片限于png,jpeg,jpg格式' );
      $form[ 0 ].reset();
      return false;
    }
    $form.ajaxSubmit( {
      type: 'post',
      url: Server.urls.upload,
      contentType: 'application/json',
      dataType: 'json',
      iframeTarget: '#myFrame',
      success: ( data ) => {
        $form[ 0 ].reset();
        Membership.renderPaymentSnapshot( $form, data, 'upload' );
      },
      error: ( msg ) => {
        $form[ 0 ].reset();
        alert( msg.responseText || '未知错误' );
      }
    } );
  },
  async submitPayment( e ) {
    const el = e.target || e.srcElement;
    const $root = $( el ).parents( '#payment-operate-modal' ).find( '#modal-wrap' );
    const $inps = $root.find( '.form-root' ).find( 'input:not([type="file"]):not([name="code"])' );
    const payload = {};
    let errorMsg = undefined;
    $.map( $inps, item => {
      const name = $( item ).attr( 'name' );
      const value = $( item ).val();
      payload[ name ] = value;
      if (!value && !errorMsg) {
        const label = $( item ).parents( '.form-group' ).find( 'label' );
        const isRequire = label.hasClass( 'required' );
        const text = label.text() || '';
        errorMsg = isRequire ? text.replace( '：', '' ) : undefined;
      }
      if (name === 'payBankAccount' && !errorMsg && !Regexp.bankCardNo.test( value )) {
        errorMsg = '请输入正确的银行卡号';
      }
    } );
    if (errorMsg) {
      alert( `请输入${ errorMsg }` );
      return false;
    }
    const certificates = $( '.upload-certificate-preview img' );
    if (certificates.length === 0) {
      alert( '请上传汇款凭证' );
      return false;
    }
    const hideData = $root.find( '.membership-hide-data' ).val() || '{}';
    const { id, year, membershipFee } = JSON.parse( hideData );
    const attachments = [];
    $.map( certificates, certificate => {
      const url = $( certificate ).attr( 'src' );
      const { name, size } = $( certificate ).data();
      if (url) {
        attachments.push( {
          name,
          size,
          url
        } );
      }
    } );
    let res;
    $( el ).attr( 'disabled', true );
    try {
      res = await Server.submitMemberFee( {
        ...payload,
        id,
        year,
        membershipFee,
        attachments
      } );
    }
    catch ( e ) {
      alert( e.responseText || '未知错误' );
    }
    $( el ).attr( 'disabled', false );
    if (res === true) {
      this.$el.find( '#payment-operate-modal' ).modal( 'hide' );
      ZCY.utils.modal( {
        type: 'success',
        content: [ '保存成功' ],
        button: [ '确定' ],
        container: $( '.membership' ),
        confirm: ( $modal ) => {
          $modal.modal( 'hide' );
          Membership.init.apply( this );
          // 未知原因弹框消失 遮罩为消失 暂时手动删除
          $( '.modal-backdrop' ).remove();
        }
      } );

      // location.reload()
    }
  },
  /**
   * 删除汇款凭证
   * @param e
   */
  deleteImg( e ) {
    const $wrap = this.$el.find( '#upload-form' ).find( '.upload-certificate' );
    const el = e.target || e.srcElement;
    $( el ).parents( '.upload-certificate-preview' ).remove();
    const $preview = $wrap.find( '.upload-certificate-preview' );
    if ($preview.length < 5) {
      $wrap.find( '.upload-certificate-upload' ).show();
    }

  }

};

module.exports = Membership;
